import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import * as icons from 'react-icons/fa';
import './Pages.css';
import API_URL from '../config/config';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";


const initialState = {
    date_time: "",
    item_code: "",
    item_name: "",
    quntity: "",
    unit_price: "",
    amount: "",
    supplier_id: "-",
    brand: "-",
    quotation_ref_no: "-",
    discription: "-"
}
export default function Add() {

    const navigate = useNavigate();
    const [cookies] = useCookies([]);

    useEffect(() => {
        const verifyUser = async () => {
            if (!cookies.jwt) {
                navigate("/");
            }
        };
        verifyUser();
    });

    const [userData, setUserData] = useState([]);
    useEffect(() => {
        const lodeUserData = async () => {
            await axios.post(API_URL + "/profile", {},
                {
                    withCredentials: true,
                })
                .then((resp) => setUserData({ ...resp.data[0] }))
        }
        lodeUserData();
    }, []);

    if (userData.account_type === "admin" || userData.account_type === "super_admin") {
        navigate("/");
    }

    const [state, setState] = useState(initialState);

    const { date_time, item_code, quntity, unit_price, supplier_id, brand, quotation_ref_no, type, discription } = state;

    const [itemNameData, setItemNameData] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    const handleCheckName = async (e) => {
        e.preventDefault();
        if (!item_code) {
            toast.error("Please enter the item code!");
        } else {
            const response = await axios.get(API_URL + `/getItemName/${item_code}`)
                .catch((err) => toast.error(err.response.data));
            setItemNameData(response.data[0]);
        }
    }


    const [typeData, setTypeData] = useState([]);

    const lodeTypeData = async () => {
        const response = await axios.get(API_URL + "/selecttypedata");
        setTypeData(response.data);

    }

    useEffect(() => {
        lodeTypeData();
    }, []);

    let amount = quntity * unit_price;
    let item_name = itemNameData.item_name;
    let user_id = userData.user_id;
    let user_fname = userData.name;


    const handleSubmit = (e) => {
        e.preventDefault();
        if (!date_time || !item_code || !item_name || !quntity || !unit_price || !amount || !type || !discription) {
            toast.error("Please fill in all data!");
        } else {
            setIsLoading(true);
            if (type === "Purchased") {
                axios.post(API_URL + "/addPurchases", {
                    date_time,
                    item_code,
                    item_name,
                    quntity,
                    unit_price,
                    amount,
                    supplier_id,
                    brand,
                    quotation_ref_no,
                    user_id,
                    user_fname

                })
            }

            axios.post(API_URL + "/addTransaction", {
                date_time,
                item_code,
                item_name,
                quntity,
                unit_price,
                amount,
                type,
                discription,
                user_id,
                user_fname

            })

                .then(() => {
                    setState({
                        date_time: "",
                        item_code: "",
                        item_name: "",
                        quntity: "",
                        unit_price: "",
                        amount: "",
                        discription: "",
                        supplier_id: "",
                        brand: "",
                        quotation_ref_no: "",
                        user_id: ""
                    });

                    toast.success("Success!");
                })

                .catch((err) => {
                    toast.error(err.response.data);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }

    }

    const [showSupplier, setshowSupplier] = useState(false);

    useEffect(() => {
        if (type === "Purchased") {
            setshowSupplier(true);
        } else {
            setshowSupplier(false);
        }
    }, [type]);

    const handleEnter = (event) => {
        if (event.key.toLowerCase() === "enter") {
            const form = event.target.form;
            const index = [...form].indexOf(event.target);
            form.elements[index + 1].focus();
            event.preventDefault();
        }
    }


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setState({ ...state, [name]: value })
    };

    return (
        <div className='background'>
            <div className='container-fluid contentbox p-5'>
                <div className='row'>
                    <div className='col-12'>
                        <div className='fleft'>
                            <a href="/dashboard">
                                <icons.FaArrowCircleLeft size='2.5em' color='#274F6A' />
                            </a>
                        </div>

                        <div className='fleft ms-2'>
                            <h2>Add</h2>
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-12 col-md-6 col-sm-9 mt-2'>

                        <form>
                            <div>
                                <h5 className="mt-2">Date:</h5>
                                <input type="date" className="form-control form-control-sm" name='date_time' onKeyDown={handleEnter} value={date_time} onChange={handleInputChange}></input>
                            </div>

                            <div>
                                <h5 className="mt-2">Item Code:</h5>
                                <input type='text' placeholder='Enter Item Code' className="form-control form-control-sm" name='item_code' onKeyDown={handleEnter} value={item_code} onChange={handleInputChange}></input>
                            </div>
                            <button className='btn btn-sm btn-secondary mt-2' onKeyDown={handleEnter} onClick={handleCheckName} >Check Name</button>
                            <div>
                                <h5 className="mt-2">Item Name:</h5>
                                <input type='text' readOnly placeholder='Check Item Name' className="form-control form-control-sm" name='item_name' onKeyDown={handleEnter} value={item_name || ''} onChange={handleInputChange}></input>
                            </div>

                            <div>
                                <h5 className="mt-2">Item Quantity:</h5>
                                <input type='text' placeholder='Enter Item Quntity' className="form-control form-control-sm" name='quntity' onKeyDown={handleEnter} value={quntity} onChange={handleInputChange}></input>
                            </div>

                            <div>
                                <h5 className="mt-2">Unit Price:</h5>
                                <input type='text' placeholder='Enter Unit Price' className="form-control form-control-sm" name='unit_price' onKeyDown={handleEnter} value={unit_price} onChange={handleInputChange}></input>
                            </div>

                            <div>
                                <h5 className="mt-2">Amount:</h5>
                                <input type='text' readOnly placeholder='Check Amount' className="form-control form-control-sm" name='amount' onKeyDown={handleEnter} value={amount} onChange={handleInputChange}></input>
                            </div>

                            <div>
                                <h5 className="mt-2">Type:</h5>
                                <select name='type' className="form-control form-control-sm" onKeyDown={handleEnter} value={type} onChange={handleInputChange}>
                                    <option value="">Select Type...</option>
                                    {
                                        typeData.map((gettype, index) => (
                                            <option value={gettype.type} key={index}>{gettype.type}</option>
                                        ))
                                    }
                                </select>
                            </div>

                            {showSupplier ? <div>
                                <div>
                                    <h5 className="mt-2">Brand:</h5>
                                    <input type='text' placeholder='Enter Brand' className="form-control form-control-sm" name='brand' onKeyDown={handleEnter} value={brand} onChange={handleInputChange}></input>
                                </div>
                                <div>
                                    <h5 className="mt-2">Supplier ID:</h5>
                                    <input type='text' placeholder='Enter Supplier ID' className="form-control form-control-sm" name='supplier_id' onKeyDown={handleEnter} value={supplier_id} onChange={handleInputChange}></input>
                                </div>
                                <div>
                                    <h5 className="mt-2">Quotation Ref. No.:</h5>
                                    <input type='text' placeholder='Enter Quotation Ref. No.' className="form-control form-control-sm" name='quotation_ref_no' onKeyDown={handleEnter} value={quotation_ref_no} onChange={handleInputChange}></input>
                                </div>
                            </div> : null}

                            <div>
                                <h5 className="mt-2">Discription:</h5>
                                <input type='text' placeholder='Enter Discription' className="form-control form-control-sm" name='discription' onKeyDown={handleEnter} value={discription} onChange={handleInputChange}></input>
                            </div>
                            <div>
                                <button type='submit' className='btn btn-sm btn-success mt-2' onClick={handleSubmit} disabled={isLoading}>
                                    {isLoading ? 'Saving...' : 'Save'}
                                </button>
                            </div>

                        </form>
                    </div>
                </div>

            </div>
            <ToastContainer />
        </div>
    )
}